export default class OurVisionContent {
  name = 'our-vision-page'
  slug = 'our-vision'
  title = `${this.name}.title`
  image = '/static/jpg/softtwining-about-us.jpg'
  imageMobile = '/static/jpg/softtwining-about-us.jpg'
  text = `${this.name}.text`
  whatWeDoButton = `${this.name}.what-we-do-button`
}